import _ from 'lodash';

export function sortPlayersByName({ playerAssessments, property = 'lastName' }:  { playerAssessments: IPlayerAssessment[], property?: 'lastName'|'firstName' }): IPlayerAssessment[] {
  return _.sortBy(playerAssessments, (playerAssessment) => {
    return playerAssessment.player?.[property];
  });
}
